var YMK = YMK || {};
var site = site || {};
var prodcat = prodcat || {};
(function ($) {
  Drupal.behaviors.productVtoV1 = {
    attached: false,
    attach: function (context, settings) {
      var self = this;
      if (self.attached) {
        return;
      }
      self.attached = true;

      var $productVTO = $('.js-product-vto', context);
      if ($productVTO.length === 0) {
        return;
      }

      var $vtoButton = $('.js-vtobtn', $productVTO);
      var $ymkModuleCont = $('.js-product-vto-container', $productVTO);
      var $mobileShadePick = $('.js-product-vto-mobile-ctrl', $productVTO);
      var $addToBagContainer = $('.js-product-vto-cart', $productVTO);
      var $addToBag = $('.js-add-to-cart', $productVTO);
      var currentSkuBaseId = $('.js-product', context).data('skuBaseId');
      var $productImages = $productVTO.closest('.product-full__media');
      var $body = $('body');
      var vtoAPIKey = settings.vto.api_key || '';
      var vtoAPIUrl = settings.vto.api_url || '';
      var skinSmoothStrength = settings.vto.skin_smooth_strength || 50;
      var vtoLanguage = Drupal.settings.common.vto_language;
      var vtoEnableConsentPage = Drupal.settings.vto_enable_consent_page;
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var breakPointMediumUp = parseInt(Unison.fetch.all()['medium'], 10);
      var isMobile = currentBpWidth < breakPointMediumUp;
      var vtoEvents = [
        'cameraClosed',
        'cameraFailed',
        'cameraOpened',
        'compare',
        'compareDisabled',
        'closed',
        'engineClosed',
        'loaded',
        'loading',
        'kissDetected',
        'opened',
        'photoLoaded',
        'photoSaved',
        'reset',
        'videoLoaded',
        'shadeFinderStarted',
        'shadeFinderComplete',
        'shadeFinderCancelled',
        'zoom'
      ];
      var ykmWidth;
      var ykmHeight;
      var currentSkuPcode;
      var widthHeightRatio = 1.22;
      var $document = $(document);

      if (vtoAPIKey) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = vtoAPIUrl + vtoAPIKey;
        var scriptElement = document.getElementsByTagName('script')[0];
        scriptElement.parentNode.insertBefore(script, scriptElement);
      }

      Unison.on('change', function () {
        var isModuleLoaded = $productVTO.find('#YMK-module-iframe').length > 0;
        var isModuleVisible = $productVTO.find('.js-product-vto-container').is(':visible');
        currentBpWidth = parseInt(Unison.fetch.now().width, 10);
        isMobile = currentBpWidth < breakPointMediumUp;
        if (typeof window.YMK.close === 'function' && isModuleLoaded && isModuleVisible) {
          window.YMK.closeEngine();
          window.YMK.close();
          $ymkModuleCont.removeClass('hidden');
          $productImages.addClass('vto-active');
          window.ymkAsyncInit(true);
        }
        if (!isMobile && !Drupal.settings.common.vto_cta_button) {
          ykmWidth = $productImages.find('.js-product-full__image').width();
          ykmWidth = ykmWidth > 700 ? 600 : ykmWidth;
          $productVTO.width(ykmWidth);
        }
      });

      window.ymkAsyncInit = function (skipEventListener) {
        var skuData;
        var vtoParams = {
          autoOpen: true,
          skinSmoothStrength: skinSmoothStrength,
          showCloseBtnOnLauncher: true,
          enableConsentPage: vtoEnableConsentPage,
          language: vtoLanguage
        };
        if (isMobile) {
          $ymkModuleCont.height($(window).height());
          window.YMK.init(vtoParams);
        } else {
          if (!Drupal.settings.common.vto_cta_button) {
            ykmWidth = $productImages.find('.js-product-full__image').width();
            ykmWidth = ykmWidth > 700 ? 600 : ykmWidth;
            ykmHeight = widthHeightRatio * ykmWidth;
            $ymkModuleCont.height('auto');
            $productVTO.width(ykmWidth);
          }
          window.YMK.init({
            ...vtoParams,
            width: ykmWidth,
            height: ykmHeight,
            language: vtoLanguage,
            enableConsentPage: vtoEnableConsentPage,
          });
        }
        if (skipEventListener || !window.YMK?.addEventListener) {
          return;
        }
        vtoEvents.forEach(function (event) {
          window.YMK.addEventListener(event, function () {
            if (event !== 'opened') {
              site.track.evtLink({
                event_name: 'YouCam',
                event_category: 'YouCam',
                event_action: event,
                event_label: 'event'
              });
            }

            var isModuleDisplayed = !$ymkModuleCont.hasClass('hidden');
            if (event === 'opened' && isModuleDisplayed) {
              $productImages.addClass('vto-active');
            }

            if (event === 'loaded') {
              skuData = prodcat.data.getSku(currentSkuBaseId);
              currentSkuPcode = skuData.PRODUCT_CODE;
              YMK.applyMakeupBySku(currentSkuPcode);
              if (isMobile) {
                $mobileShadePick.removeClass('hidden');
                $productVTO.trigger('resize');
                $('.js-product', context).trigger('product.skuSelect', currentSkuBaseId);
              }
            }

            if (event === 'closed') {
              skuData = prodcat.data.getSku(currentSkuBaseId);
              if (isMobile) {
                $mobileShadePick.addClass('hidden');
              }
              if (skuData && skuData.VTO_FLAG_ONLINE) {
                $vtoButton.removeClass('disabled');
              }
              $ymkModuleCont.addClass('hidden');
              $productImages.removeClass('vto-active');
              $body.removeClass('no-scroll product-vto-feature');
              window.YMK.closeEngine();
            }
          });
        });
      };

      $vtoButton.once().on('click', function (e) {
        e.preventDefault();
        var isModuleDisplayed = !$ymkModuleCont.hasClass('hidden');
        if (typeof window.YMK.close === 'function' && isModuleDisplayed) {
          window.YMK.closeEngine();
          window.YMK.close();
        }
        $(this).addClass('disabled');
        $ymkModuleCont.removeClass('hidden');
        $productImages.addClass('vto-active');
        if (isMobile) {
          // Disable scrolling
          window.scrollTo(0, 0);
          $body.addClass('no-scroll product-vto-feature');
        }
        window.ymkAsyncInit(true);
        // ASMBLY8-599 tracking VTO opened event only when trigger clicked
        site.track.evtLink({
          event_name: 'YouCam',
          event_category: 'YouCam',
          event_action: 'opened',
          event_label: 'event'
        });
      });

      $document.on('product.skuSelect', '.js-product', function (e, skuBaseId) {
        // Update shadename
        var skuData = prodcat.data.getSku(skuBaseId);
        var $shadeSwatch = $('.js-sku-shade-name', $mobileShadePick);
        var $shadeColor = $('.js-sku-shade-smoosh-reaction', $mobileShadePick);
        currentSkuBaseId = skuData.SKU_BASE_ID;

        // Update mobile swatches
        $shadeSwatch.html(skuData.SHADENAME);
        $shadeColor.css('background-color', skuData.HEX_VALUE_STRING);

        // Update shadename in shade dropdown menu
        var $product = $(this);
        var $listeners = $product.find('[mantle-sku-select-hub="1"]');
        if ($listeners.length > 0) {
          $listeners.trigger('changeSelectToSku', [$product, skuBaseId]);
        }

        // Change the shade
        currentSkuPcode = skuData.PRODUCT_CODE;
        if (YMK && typeof YMK.applyMakeupBySku === 'function') {
          YMK.applyMakeupBySku(currentSkuPcode);
        }

        // Enable/disable the VTO button
        skuData.VTO_FLAG_ONLINE
          ? $vtoButton.removeClass('disabled')
          : $vtoButton.addClass('disabled');
      });

      $document.on('addToCart.success', function () {
        var addedText = $addToBagContainer.data('addedText');
        var addToBagText = $addToBag.html();
        if (addToBagText !== addedText) {
          $addToBag.html(addedText);
          setTimeout(function () {
            $addToBag.html(addToBagText);
          }, 3000);
        }
      });
    }
  };

  $(document).on('product.skuSelect', '.js-product', function (e, skuBaseId) {
    var $vtoButton = $('.js-vtobtn', $(this));
    var skuData = prodcat.data.getSku(skuBaseId);
    if (skuData && skuData.VTO_FLAG_ONLINE) {
      $vtoButton.removeClass('disabled');
    } else {
      $vtoButton.addClass('disabled');
    }
  });
})(jQuery);
